import type { Marketplace, StockGuardSettings } from '@/lib/api/schemas/stock-guard.schema'
import { marketplaceLabel } from '@/lib/stock-guard-format'
import { Switch } from '@/components/ui/Switch'

type Props = {
  value: StockGuardSettings
  canManage: boolean
  busy: boolean
  onChange: (marketplace: Marketplace, enabled: boolean) => Promise<void>
}

export function ChannelKillSwitches({ value, canManage, busy, onChange }: Props) {
  const channels: Array<{ marketplace: Marketplace; enabled: boolean; permitted: boolean }> = [
    { marketplace: 'wildberries', enabled: value.settings.zeroOnWildberries, permitted: value.permitted.zeroOnWildberries },
    { marketplace: 'yandex-market', enabled: value.settings.zeroOnYandex, permitted: value.permitted.zeroOnYandex },
  ]

  return (
    <div className="grid gap-3 p-4 sm:grid-cols-2 sm:p-5">
      {channels.map(({ marketplace, enabled, permitted }) => (
        <div key={marketplace} className="rounded-md border border-rule bg-ivory/60 p-4">
          <div className="flex items-center justify-between gap-4">
            <div>
              <p className="font-semibold text-ink">Запись на {marketplaceLabel(marketplace)}</p>
              <p className="mt-1 text-xs text-ink-muted">Опрос продолжает фиксировать продажи при выключенной записи.</p>
            </div>
            <Switch
              checked={enabled}
              label={`Запись на ${marketplaceLabel(marketplace)}`}
              disabled={!canManage || busy}
              onChange={() => void onChange(marketplace, !enabled)}
            />
          </div>
          <p className={`mt-3 text-xs font-semibold ${permitted ? 'text-st-delivered' : 'text-st-unpaid'}`}>
            {permitted ? 'Удалённая запись разрешена' : value.dryRun ? 'Аварийный dry-run: запись заблокирована' : 'Удалённая запись заблокирована'}
          </p>
        </div>
      ))}
    </div>
  )
}
